import isNil from 'lodash/isNil';
import { boolean, number, object, string } from 'yup';

export const validationSchema = () =>
  object({
    enabled: boolean(),
    uniq_id: string(),
    start_at: number()
      .nullable()
      .test('start_at', 'Field is required', (v: number | null | undefined) => !isNil(v)),
    end_at: number().nullable(),
    min_pause_between_series: number().test(
      'min_pause_between_series',
      'Field is required',
      (v: number | undefined) => !isNil(v) && v > 0,
    ),
    max_pause_between_series: number()
      .test(
        'max_pause_between_series',
        'Field is required',
        (v: number | undefined) => !isNil(v) && v > 0,
      )
      .test('match', 'Should be more than min value', function (max_pause) {
        const maxDuration = max_pause ?? 0;
        const minDuration = this.parent?.min_pause_between_series ?? 0;
        return maxDuration >= minDuration;
      }),
    min_volume: number().required('Field is required').positive('Field is required'),
    max_volume: number()
      .required('Field is required')
      .positive('Field is required')
      .test('match', 'Should be more than min value', function (max_volume) {
        return Number(max_volume) >= Number(this.parent?.min_volume ?? 0);
      }),
    batch_wallets_min: number().required('Field is required').min(1, 'Min value is 1'),
    batch_wallets_max: number()
      .required('Field is required')
      .min(1, 'Min value is 1')
      .test('match', 'Should be more than min value', function (maxW) {
        return Number(maxW) >= Number(this.parent?.batch_wallets_min ?? 0);
      }),
  });
